module.exports = __webpack_public_path__ + "media/flags/re-ee67e77c.svg";